<template>
    <div class="h-full w-full flex flex-col sm:flex-row shadow-2xl border rounded-lg">
        <div class="xl:h-72 2xl:min-h-56 w-full sm:w-72 flex-shrink-0">
            <img class="h-full w-full object-contain bg-indigo-50 rounded-tl-lg rounded-tr-lg sm:rounded-tr-none rounded-bl-none sm:rounded-bl-lg" :src="getImage" alt="thumbnail">
        </div>
        <div class="bg-white p-4 flex flex-col justify-between leading-normal rounded-bl-lg sm:rounded-bl-none rounded-br-lg rounded-tr-none sm:rounded-tr-lg">
            <div class="mb-6 xl:mb-8">
                <div class="text-gray-900 font-bold text-base sm:text-lg xl:text-xl mb-2" v-html="item.title"></div>
                <p class="text-gray-700 text-sm sm:text-base" v-html="item.description"></p>
            </div>
            <div class="flex justify-between items-center">
                <div class="flex items-center">
                    <img class="w-8 sm:w-10 h-8 sm:h-10 rounded-full mr-2 sm:mr-4 object-contain border" :src="getEntityImage" alt="thumbnail">
                    <div class="text-xs sm:text-sm">
                        <p class="text-gray-900 leading-none uppercase">{{ item.name }}</p>
                        <p class="text-gray-600">{{ item.entity.entity }}</p>
                    </div>
                </div>
                <div>
                <router-link v-if="isReadMore" :to="`/success-stories/${item.id}`" class="h-full w-full flex justify-center items-center cursor-pointer border border-primary text-white hover:text-primary view-all bg-primary hover:bg-white transition-all duration-200 px-4 py-2">
                    <div class="leading-none mr-1 text">Read more</div>
                    <icon-right-arrow class="w-5 h-5 icon transition-all duration-200 ease-bounce"></icon-right-arrow>
                </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconRightArrow from "../icons/IconRightArrow.vue";
export default {
    name: "story-card",
    props: ["item", "isReadMore"],
    components: {
        IconRightArrow,
    },
    computed: {
        getImage() {
            return process.env.VUE_APP_PUBLIC_URL + this.item.thumbnail;
        },
        getEntityImage() {
            return process.env.VUE_APP_PUBLIC_URL + this.item.entity.logo;
        },
    },
}
</script>

<style lang="scss" scoped>
.view-all {
  &:hover {
    .text {
      font-weight: 600;
    }
    .icon {
      transform: translateX(0.25rem);
    }
  }
}
.ease-bounce {
    transition-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1.3);
}
</style>